import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5193d5dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-nogutter col-12 md:col-10 md:col-offset-1 lg:col-8 lg:col-offset-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "grid grid-nogutter col-12 center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12" }, "Feature Request"),
  /*#__PURE__*/_createElementVNode("p", { class: "col-12" }, [
    /*#__PURE__*/_createTextVNode(" Add, edit and delete features that you wish to be implemented in a future release. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("One or more features may be implemented depending on their complexity and priority! "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "text--mini" }, "Upon a feature being confirmed, please contact the developer if you do not wish to have the feature implemented anymore, as its development might already be in progress.")
  ])
], -1))
const _hoisted_3 = { class: "grid grid-nogutter col-12 container-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "New", -1))
const _hoisted_5 = { class: "pl-2 text-center md:pl-0 md:text-left w-full" }
const _hoisted_6 = { class: "center" }
const _hoisted_7 = { class: "center" }

import { onMounted, Ref, ref } from "vue"
import { useConfirm } from "primevue/useconfirm"
import FeatureRequestDetailsModal from "@/views/feature-requests/FeatureRequestDetailsModal.vue"
import FeatureRequest from "@/models/feature-requests/FeatureRequest"
import FeatureRequestController from "@/controllers/feature-requests/FeatureRequestController"
import { useToast } from "primevue/usetoast"
import { DataTableRowEditSaveEvent } from "primevue/datatable"

/* ------------------- Properties ----------------- */

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureRequest',
  setup(__props) {

const toast = useToast()
const confirm = useConfirm()

const featureRequestController = new FeatureRequestController()

const isDetailsOpen = ref(false)
const editFeatureRequestId: Ref<string> = ref("")

const featureRequests: Ref<FeatureRequest[]> = ref([])

/* ------------------- Methods ----------------- */

async function loadData() {
	featureRequests.value = await getFeatureRequests()
}

async function getFeatureRequests() {
	return featureRequestController.getAll()
}

function openDetailsModal(featureId: string = "") {
	editFeatureRequestId.value = featureId
	changeDetailsModalState(true)
}

function changeDetailsModalState(isOpening: boolean) {
	isDetailsOpen.value = isOpening
}

function deleteFeatureRequest(event: Event, featureRequest: FeatureRequest) {
	confirm.require({
		target: event.currentTarget as HTMLElement,
		message: `Are you sure you want to delete "${featureRequest.title}"?`,
		icon: "fas fa-exclamation-triangle",
		acceptClass: "p-button-danger",
		accept: async () => {
			await featureRequestController.delete(featureRequest.id)
			loadData()
			return toast.add({ severity: "success", summary: "Success", detail: `Successfully deleted "${featureRequest.title}"`, life: 3000 })
		},
		reject: () => {
			return
		}
	})
}

/*
//If I want to make the row a certain colour for example when confirmed, instead of having a checkmark there.
function getRowClass(data: any) {
	let rowClass = "";

	if (data.isConfirmed) {
		rowClass = "confirmed-feature"
	}

	return rowClass
}
*/

function saveRowEdit(event: DataTableRowEditSaveEvent) {
	featureRequests.value[event.index] = event.newData
}

/* ------------------- Lifecycle ----------------- */
onMounted(async () => {
	//const auth = getAuth(firebaseApp);
	loadData()
})


return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_toolbar = _resolveComponent("p-toolbar")!
  const _component_p_column = _resolveComponent("p-column")!
  const _component_p_data_table = _resolveComponent("p-data-table")!
  const _component_p_confirm_popup = _resolveComponent("p-confirm-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      _createVNode(_component_p_toolbar, { class: "mb-2 col-12 p-1" }, {
        start: _withCtx(() => [
          _createVNode(_component_p_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openDetailsModal())),
            class: "p-button-success"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_fa, {
                icon: ['fas', 'plus'],
                size: "1x"
              }),
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_p_data_table, {
        value: featureRequests.value,
        "data-key": "id",
        removableSort: "",
        stripedRows: "",
        sortMode: "multiple",
        onRowEditSave: saveRowEdit,
        responsiveLayout: "stack",
        breakpoint: "720px",
        class: "col-12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_p_column, {
            field: "title",
            header: "Title",
            style: {"width":"70%"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(slotProps.data.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_p_column, {
            field: "priority",
            header: "Priority",
            sortable: "",
            "sort-field": "priority.id",
            style: {"width":"5%"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(slotProps.data.priority.label), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_p_column, {
            field: "isConfirmed",
            header: "Confirmed",
            sortable: "",
            style: {"width":"5%"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_7, [
                (slotProps.data.isConfirmed)
                  ? (_openBlock(), _createBlock(_component_fa, {
                      key: 0,
                      icon: ['fas', 'check'],
                      class: "text-success"
                    }))
                  : (_openBlock(), _createBlock(_component_fa, {
                      key: 1,
                      icon: ['fas', 'question'],
                      class: "text-secondary"
                    }))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_p_column, {
            exportable: false,
            style: {"width":"15%","justify-content":"end"},
            "body-class": "text-center"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_p_button, {
                class: "col-2 md:col-12 lg:col-5 p-button-rounded p-button-primary justify-content-center mr-1",
                onClick: ($event: any) => (openDetailsModal(slotProps.data.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa, {
                    icon: ['fas', 'pencil-alt'],
                    size: "1x"
                  })
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_p_button, {
                disabled: slotProps.data.isConfirmed,
                onClick: ($event: any) => (deleteFeatureRequest($event, slotProps.data)),
                class: "col-2 md:col-12 lg:col-5 p-button-rounded p-button-danger justify-content-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa, {
                    icon: ['fas', 'trash'],
                    size: "1x"
                  })
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(FeatureRequestDetailsModal, {
      "is-open": isDetailsOpen.value,
      "feature-request-id": editFeatureRequestId.value,
      onChangeOpenState: changeDetailsModalState,
      onSaved: loadData
    }, null, 8, ["is-open", "feature-request-id"]),
    _createVNode(_component_p_confirm_popup)
  ]))
}
}

})